/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { CompaniesService } from '@app/settings/companies/companies.service';
import { CompaniesFormService } from '@app/settings/companies/companies-form.service';
import { Company } from '@app/settings/companies/company.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { MediaLibraryAcceptTypes } from '@app/shared/components/media-library/media-library-accept-types.enum';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { environment } from '@env/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('CompaniesListComponent');

@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss'],
})
export class CompaniesListComponent extends KendoGridComponent implements OnInit {
  companiesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  MediaLibraryAcceptTypes = MediaLibraryAcceptTypes;
  LaravelModels = LaravelModelsEnum;
  env = environment;
  UserRoleType = UserRoleType;

  constructor(
    private companiesService: CompaniesService,
    private companiesFormService: CompaniesFormService,
    protected kendoGridService: KendoGridService,
    private sanitizer: DomSanitizer,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('CompaniesListComponent');
    this.loadData(this.state);
  }

  /**
   * Open companies form
   */
  add() {
    this.companiesFormService.open().then(
      () => {
        this.loadData(null, true);
      },
      () => {
        log.debug('modal closed');
      }
    );
  }

  /**
   *
   * @param company Company object
   */
  edit(company: Company) {
    this.companiesFormService.open(company).then(
      () => {
        this.loadData();
      },
      () => {
        log.debug('modal closed');
      }
    );
  }

  /**
   *
   * @param company Company object
   */
  delete(company: Company) {
    this.companiesService.destroy(company.id).subscribe(() => {
      this.loadData(this.state, true);
    });
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null, forceUpdate: boolean = false) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state).addIncludes('city.country', 'websites', 'contacts.type', 'logo');

    this.companiesService.index(this.apiQuery, forceUpdate).subscribe((response: PaginatedResponse) => {
      this.companiesResponse = response;
      this.data = response.getGridData();
    });
    CustomKendoFilter.pushStateInStorage('CompaniesListComponent', this.state);
  }

  /**
   * чупи адреса без това
   *  https://stackoverflow.com/questions/46041210/angular-2-ngstyle-and-background-image
   * @param imgStr img
   */
  getBackgroundImg(imgStr: string) {
    const imageString = JSON.stringify(imgStr).replace(/\\n/g, '');
    const style = 'url(' + imageString + ')';
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
